import {ChartEventDomainModel} from "./chart-event.domain-model";
import {ChartEventViewModel} from "./chart-event.view-model";

export class ChartEventShotViewModel extends ChartEventViewModel {
  domainModel: ChartEventDomainModel

  constructor(model: ChartEventDomainModel, x, y, isActive) {
    super(model);

    this.x = x;
    this.y = y;
    this.isActive = isActive;
  }
}
